import FieldNotesLayer from './FieldNotesLayer';
import PotholesLayer from './PotholesLayer';

/**
 * The project's "Site Data" overlays (Field Notes + Potholes) as a single mount, so a map host
 * that offers the Site Data leaves in its layer picker can also draw them.
 * Each child decides for itself whether to draw.
 *
 * `interactive={false}` draws the markers without their click affordances, for read-only
 * surfaces such as the CivilDraw print view.
 */
export default function SiteDataLayers({
  projectId,
  interactive = true,
}: {
  projectId: string;
  interactive?: boolean;
}) {
  return (
    <>
      <FieldNotesLayer projectId={projectId} interactive={interactive} />
      <PotholesLayer projectId={projectId} interactive={interactive} />
    </>
  );
}
